import React from 'react';
import verifyCheckIcon from '@/assets/images/verified_checkbox.png';
import verifyCheckWhiteIcon from '@/assets/images/white_check.png';
import classes from './verifyInfo.module.scss';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import t from '@/utils/Language/ResourceCard-translations';
import moment from 'moment';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

const getVerifyState = (lastVerifiedDate) => {
  const monthsDiff = moment().diff(moment(lastVerifiedDate), 'months');
  if (monthsDiff < 6) return 'fresh';
  if (monthsDiff < 18) return 'semiStale';
  return 'stale';
};

export const VerifyInfo = ({ resource, iconOnly = true }) => {
  const state = getVerifyState(resource.last_verified_at);

  const popoverFresh = (
    <Popover id="popover-verified" className={classes.popoverContainerFresh}>
      <Popover.Header as="h2" className={classes.popoverHeader}>
        <Image src={verifyCheckWhiteIcon} alt="verify" height={18} width={18} />
        {t('Verified Information')}
      </Popover.Header>
      <Popover.Body className={classes.popoverBody}>{t('One Degree values quality and updates all information every six months.')}</Popover.Body>
    </Popover>
  );

  const popoverSemiStale = (
    <Popover id="popover-semi-stale" className={classes.popoverContainerSemiStale}>
      <Popover.Header as="h2" className={classes.popoverHeader}>
        <FontAwesomeIcon icon="fa-solid fa-info-circle" />
        {t('Information Status')}
      </Popover.Header>
      <Popover.Body className={classes.popoverBody}>
        {t('This information has not been updated in the past 6 months. Please contact this specific organization for the most up-to-date details.')}
      </Popover.Body>
    </Popover>
  );

  const popoverStale = (
    <Popover id="popover-stale" className={classes.popoverContainerStale}>
      <Popover.Header as="h2" className={classes.popoverHeader}>
        <FontAwesomeIcon icon="fa-solid fa-info-circle" />
        {t('Information Status')}
      </Popover.Header>
      <Popover.Body className={classes.popoverBody}>
        {t('This information has not been updated in the past 18 months. Please contact this specific organization for the most up-to-date details.')}
      </Popover.Body>
    </Popover>
  );

  const overlayMap = { fresh: popoverFresh, semiStale: popoverSemiStale, stale: popoverStale };

  const icon =
    state === 'fresh' ? <Image src={verifyCheckIcon} alt="verify" height={14} width={14} /> : <FontAwesomeIcon icon="fa-solid fa-info-circle" />;
  const label = state === 'fresh' ? t('Verified Information') : t('Information Status');

  const target = iconOnly ? (
    <span className={`${classes.verifyIcon} ${classes[state]}`}>{icon}</span>
  ) : (
    <div className={`${classes.verifyBadge} ${classes[state]}`}>
      {icon}
      <span>{label}</span>
    </div>
  );

  return (
    <OverlayTrigger placement="bottom" overlay={overlayMap[state]}>
      {target}
    </OverlayTrigger>
  );
};
